import _ from 'lodash'
import {NextRouter} from 'next/router'

export const removeQueryParamByName = (router: NextRouter, paramName: string): void => {
  if (!router || !router.isReady || !router.query || !paramName) return

  const newQuery = _.omit(router.query, paramName)
  router.push({pathname: router.pathname, query: newQuery}, undefined, {shallow: true})
}

export const addQueryParam = (router: NextRouter, queryParam: Record<string, any>): void => {
  if (!router || !router.isReady || !router.query || _.isEmpty(queryParam)) return

  const newQuery = _.merge({}, router.query, queryParam)
  router.push({pathname: router.pathname, query: newQuery}, undefined, {shallow: true})
}
